export enum KeyboardCodes {
  Enter = 'Enter'
}